/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getReleaseMetricsScanMetrics,
  releaseMetricsPageReducer
} from './../reducers';

import { chart, metrics as metricConstants } from './../helpers';
import { colours } from './../helpers';

export const mapStateToProps = (state) => {
  const info = releaseMetricsPageReducer.getReleaseMetricsInfo(state);
  const metrics = getReleaseMetricsScanMetrics(state);
  const ccfData = metrics.map(m => m && m.ccf.search ? m.ccf.search : null);
  const ncfData = metrics.map(m => m && m.ncf.search ? m.ncf.search : null);
  const ccfAvg = metricConstants.getRollingAverage(ccfData, 0.10);
  const ncfAvg = metricConstants.getRollingAverage(ncfData, 0.10);

  const pointRadius = metrics ? 0 : 4;

  return {
    data: [ccfData, ccfAvg, ncfData, ncfAvg],
    series: [
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Duration',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Average Duration',
        pointRadius,
        borderWidth: 1
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Duration',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Average Duration',
        pointRadius,
        borderWidth: 1
      }
    ],
    labels: metrics.map(m => m.productVersion),
    orphanPointRadius: 4,
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          title: (tooltipItem) =>
            chart.releaseMetricsVersionTooltipTitle(tooltipItem)(info, metrics),
          footer: (tooltipItem) => chart.metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/ReleaseMetricsDurationChartContainer.jsx